const calculateRetryTime = (timeBeforeRetryS: number): Date => {
  const secondToMilliseconds = 1000;
  return new Date(Date.now() + timeBeforeRetryS * secondToMilliseconds);
};

export default calculateRetryTime;
